import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import { Heading } from "components/Heading";
import { LoaderFallbackUI } from "components/LoaderFallbackUI";
import DataTable from "components/DataTable/DataTable";
import { Pagination } from "components/Pagination";
import { blsListing } from "api/api.service";
import { useLocalPaginatedRequest } from "hooks/useLocalPaginatedRequest";
import { convertDateTime, dateTimeFormat } from "utils/dateFormatUtils";
import { Affirmations } from "constants";
import typography from "../typography";

export default function BlsSessions() {
    const { id } = useParams();

    const { isFetching, page, total, data, handlePageClick, onChangePageSize, pageSize } =
        useLocalPaginatedRequest(blsListing, { userId: id }, [id]);

    if (isFetching && !data) return <LoaderFallbackUI isLoader={isFetching} />;

    return (
        <div className="profile-details-con p-4 mt-3">
            <Heading heading={typography.BLS_SESSIONS} />
            {data?.length === 0 ? (
                <p className="data-not-found-typo standard-typo-16-600 mt-3">
                    {typography.NO_BLS_SESSIONS}
                </p>
            ) : (
                <>
                    <DataTable
                        data={data}
                        loading={isFetching}
                        config={[
                            {
                                title: typography.DATE,
                                render: (row) => (
                                    <div className="standard-typo-14-400">
                                        {convertDateTime({
                                            date: row.createdAt,
                                            customFormat: dateTimeFormat.monthLetterDateFormat,
                                        }) || "-"}
                                    </div>
                                ),
                            },
                            {
                                title: typography.CATEGORY,
                                render: (row) => (
                                    <div className="standard-typo-14-400">
                                        {row.affirmation?.affirmationType
                                            ? Affirmations.getDisplayTextKey(
                                                  row.affirmation.affirmationType
                                              )
                                            : typography.QUICK_RESET}
                                    </div>
                                ),
                            },
                            {
                                title: typography.BLS_DURATION,
                                render: (row) => (
                                    <div className="standard-typo-14-400">
                                        {row.duration ? `${row.duration}s` : "-"}
                                    </div>
                                ),
                            },
                            {
                                title: typography.FEEDBACK,
                                render: (row) => (
                                    <div className="standard-typo-14-400">
                                        {row.feedbackFormSubmittedAt
                                            ? typography.SUBMITTED
                                            : typography.NOT_SUBMITTED}
                                    </div>
                                ),
                            },
                            {
                                title: typography.RATING,
                                render: (row) => (
                                    <div className="standard-typo-14-400">
                                        {/* 0 is what the web feedback form sends when it asks
                                            no rating question — not a rating. The scale is 1-10. */}
                                        {row.rating >= 1 ? `${row.rating}/10` : "-"}
                                    </div>
                                ),
                            },
                        ]}
                    />
                    <Pagination
                        onPageClick={handlePageClick}
                        currentPage={page}
                        totalData={total}
                        handleChange={(e) => onChangePageSize(e)}
                        rowLimit={pageSize}
                    />
                </>
            )}
        </div>
    );
}
